// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"251":"473d14c7","453":"acca0757","491":"f6cce4c0","744":"db83eab2","992":"1dd0d2f8"}[chunkId] + ".chunk.js";
};